import type { TableColumnsType } from 'antd';
import { DataTypeReportFunctions } from 'store/ducks/Reportings/types';

export const columns: TableColumnsType<DataTypeReportFunctions> = [
  {
    title: 'Name of the financial entity',
    width: 100,
    dataIndex: 'entity_name',
    key: 'entity_name',
    fixed: 'left',
  },
  {
    title: 'Function identifier',
    width: 100,
    dataIndex: 'function_identifier',
    key: 'function_identifier',
  },
  {
    title: 'Function name',
    width: 100,
    dataIndex: 'function_name',
    key: 'function_name',
  },
  {
    title: 'Alternatives exit',
    width: 100,
    dataIndex: 'alternatives_exit',
    key: 'alternatives_exit',
  },
  {
    title: 'Criticality assessment',
    width: 100,
    dataIndex: 'criticality_assessment',
    key: 'criticality_assessment',
  },
  {
    title: 'Dora criticality',
    width: 100,
    dataIndex: 'dora_criticality',
    key: 'dora_criticality',
  },
  {
    title: 'Function level',
    width: 100,
    dataIndex: 'function_level',
    key: 'function_level',
  },
  {
    title: 'Impact of discontinuing',
    width: 100,
    dataIndex: 'impact_of_discontinuing',
    key: 'impact_of_discontinuing',
  },
  {
    title: 'Licensed activity',
    width: 100,
    dataIndex: 'licensed_activity',
    key: 'licensed_activity',
  },
  {
    title: 'Possibility of reintegration',
    width: 100,
    dataIndex: 'possibility_of_reintegration',
    key: 'possibility_of_reintegration',
  },
  {
    title: 'Date of last assessment',
    width: 100,
    dataIndex: 'date_of_last_assessment',
    key: 'date_of_last_assessment',
  },
  {
    title: 'Functions Valid from',
    width: 100,
    dataIndex: 'start_date',
    key: 'start_date',
  },
  {
    title: 'Functions Valid to',
    width: 100,
    dataIndex: 'end_date',
    key: 'end_date',
  },
  {
    title: 'Reasons for criticality',
    width: 100,
    dataIndex: 'reasons_for_criticality',
    key: 'reasons_for_criticality',
  },
  {
    title: 'Recovery point objective',
    width: 100,
    dataIndex: 'recovery_point_objective',
    key: 'recovery_point_objective',
  },
  {
    title: 'Recovery time objective',
    width: 100,
    dataIndex: 'recovery_time_objective',
    key: 'recovery_time_objective',
  },
  {
    title: 'Description',
    width: 100,
    dataIndex: 'description',
    key: 'description',
  },
  {
    title: 'Selected Date',
    width: 100,
    dataIndex: 'date',
    key: 'date',
  },
];
